import _defineProperty from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Component } from 'react';
import { casinoIdStatus as PlayerStatus } from '../../api/PlayerInfoConstants';
import Screens from '../../screens';
import { RewardCenterTabs } from '../../screens/RewardCenter/Constants';
import QueryParamsProxy from '../../utils/queryParamProxy';
import routeParamConstants, { ShopTypes } from '../../utils/routeParamConstants';
import { isStar } from '../../utils/targetApplication';
import { TooltipTypes } from '../../utils/tooltipConstants';
import { EVENT_TYPES } from '../../lib/analytics/constants';
import Logger from '../../lib/analytics/logger';
import ENVIRONMENT_VARIABLES from '../../utils/environmentVariables';

var Tier = /*#__PURE__*/function (_Component) {
  _inherits(Tier, _Component);

  var _super = _createSuper(Tier);

  function Tier() {
    var _this;

    _classCallCheck(this, Tier);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this._buyClickHandler = function () {
      var _QueryParamsProxy$set;

      Logger.setActionTrigger('topBar');
      QueryParamsProxy.setQueryParams((_QueryParamsProxy$set = {}, _defineProperty(_QueryParamsProxy$set, routeParamConstants.PARAM_MODAL, Screens.Shop), _defineProperty(_QueryParamsProxy$set, routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.COINS), _QueryParamsProxy$set));
      var trigger = Logger.getActionTrigger();
      var eventPayload = {
        balance_before: _this.props.coin.value.toString(),
        type: 'regular',
        trigger: trigger || ''
      };
      Logger.sendEvent(EVENT_TYPES.STORE_OPENED, eventPayload);
    };

    _this.handleClick = function () {
      var _QueryParamsProxy$set4;

      var _this$props = _this.props,
          isAccountLinked = _this$props.isAccountLinked,
          casinoIdStatus = _this$props.casinoIdStatus,
          _this$props$activeCon = _this$props.activeConsumables;
      _this$props$activeCon = _this$props$activeCon === void 0 ? {} : _this$props$activeCon;
      var vip_room_access = _this$props$activeCon.vip_room_access; // account is not linked.

      if (isAccountLinked === 'no') {
        QueryParamsProxy.setQueryParams(_defineProperty({}, routeParamConstants.PARAM_MODAL, Screens.LinkAccount));
        return;
      } // is digitally verified and no vip access (str)


      if (casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED && !vip_room_access) {
        var _QueryParamsProxy$set3;

        QueryParamsProxy.setQueryParams((_QueryParamsProxy$set3 = {}, _defineProperty(_QueryParamsProxy$set3, routeParamConstants.PARAM_MODAL, Screens.Shop), _defineProperty(_QueryParamsProxy$set3, routeParamConstants.PARAM_SHOP_TYPE, ShopTypes.VIP), _QueryParamsProxy$set3));
        return;
      } // linked account


      !isStar && QueryParamsProxy.setQueryParams((_QueryParamsProxy$set4 = {}, _defineProperty(_QueryParamsProxy$set4, routeParamConstants.PARAM_MODAL, Screens.RewardCenter), _defineProperty(_QueryParamsProxy$set4, routeParamConstants.PARAM_RC_TAB, RewardCenterTabs.PROFILE), _QueryParamsProxy$set4));
    };

    _this.tooltipClickHandler = function () {
      var _this$props2 = _this.props,
          navigation = _this$props2.navigation,
          isAccountLinked = _this$props2.isAccountLinked,
          casinoIdStatus = _this$props2.casinoIdStatus;
      if (isAccountLinked !== 'yes') return;

      if (casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED) {
        _this._buyClickHandler();
      } else {
        QueryParamsProxy.navigate(navigation, Screens.VIP);
      }
    };

    _this.tooltipAttributes = function () {
      var _this$props3 = _this.props,
          memberLevel = _this$props3.memberLevel,
          casinoIdStatus = _this$props3.casinoIdStatus,
          isAccountLinked = _this$props3.isAccountLinked,
          activeConsumables = _this$props3.activeConsumables;

      if (isAccountLinked === 'yes') {
        if (casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED && activeConsumables.vip_room_access) {
          return {
            title: 'You already have a VIP pass',
            buttonLabel: 'PLAY'
          };
        }

        if (casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED && ENVIRONMENT_VARIABLES.SHOW_TIER_TOOLTIP_IF_PHYSICALLY_VERIFIED !== 'false') {
          return memberLevel ? {
            title: 'Get 1 Tier Point for every $20 you spend on Coins!',
            buttonLabel: 'BUY NOW'
          } : {
            title: 'This feature is currently not available. Please check back later.'
          };
        }
      }

      return {
        title: null,
        buttonLabel: null
      };
    };

    return _this;
  }

  _createClass(Tier, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          memberLevel = _this$props4.memberLevel,
          isAccountLinked = _this$props4.isAccountLinked,
          casinoIdStatus = _this$props4.casinoIdStatus,
          activeConsumables = _this$props4.activeConsumables,
          assetsUrls = _this$props4.assetsUrls,
          linkCardAssets = _this$props4.linkCardAssets;

      var changeTooltipType = function changeTooltipType() {
        return _this2.props.changeTooltipType(_this2.props.tooltipType === TooltipTypes.TIER ? null : TooltipTypes.TIER);
      };

      var _this$tooltipAttribut = this.tooltipAttributes(),
          tooltipTitle = _this$tooltipAttribut.title,
          tooltipButtonLabel = _this$tooltipAttribut.buttonLabel;

      return this.props.render({
        hasVipAccess: activeConsumables && activeConsumables.vip_room_access,
        digitallyVerified: casinoIdStatus === PlayerStatus.DIGITALLY_VERIFIED,
        starDataUnavailable: isAccountLinked === 'yes' && casinoIdStatus === PlayerStatus.PHYSICALLY_VERIFIED && !memberLevel,
        clickHandler: this.handleClick,
        tooltipClickHandler: this.tooltipClickHandler,
        memberLevel: memberLevel,
        isAccountLinked: isAccountLinked,
        tooltipTitle: tooltipTitle,
        tooltipButtonLabel: tooltipButtonLabel,
        changeTooltipType: changeTooltipType,
        linkCardAssets: linkCardAssets,
        assetsUrls: assetsUrls
      });
    }
  }]);

  return Tier;
}(Component);

export { Tier as default };